'use client'
import { useCallback, useRef } from 'react'
import LightGallery from 'lightgallery/react'
import { Media } from '@/payload-types'

import 'lightgallery/css/lightgallery.css'
import 'lightgallery/css/lg-zoom.css'
import 'lightgallery/css/lg-share.css'
import 'lightgallery/css/lg-thumbnail.css'
import 'lightgallery/css/lg-video.css'

import lgThumbnail from 'lightgallery/plugins/thumbnail'
import lgVideo from 'lightgallery/plugins/video'
import lgHash from 'lightgallery/plugins/hash'
import lgShare from 'lightgallery/plugins/share'
import { LightGallery as LightGalleryObject } from 'lightgallery/lightgallery'
import CarouselGalleryComponent from '../carousel-gallery/carousel-gallery'
import { GalleryItem } from 'lightgallery/lg-utils'

interface IProps {
  gallery?: (string | Media)[] | null
}

function splitImageOrVideo(item: Media) {
  const payload_url = process.env.NEXT_PUBLIC_PAYLOAD_URL ? process.env.NEXT_PUBLIC_PAYLOAD_URL : ''
  if (item && typeof item === 'object') {
    if (item.mimeType?.startsWith('image')) {
      return {
        src: `${payload_url}${item.sizes?.webp?.url}`,
        thumb: `${payload_url}${item.sizes?.thumbnail?.url}`,
        title: item.title
      }
    } else {
      const startTime = item?.startPosition ? item?.startPosition : 0
      return {
        video: {
          source: [
            {
              src: `${payload_url}${item.url}?#t=${startTime}`,
              type: 'video/mp4',
              poster: `${payload_url}${
                item.coverImage && typeof item.coverImage === 'object'
                  ? item.coverImage.sizes?.large?.url
                  : ''
              }`,
            },
          ],
          attributes: {
            preload: 'none',
            controls: true,
          } as HTMLVideoElement,
          tracks: [],
        },
        startTime: startTime,
        thumb: `${payload_url}${
          item.coverImage && typeof item.coverImage === 'object'
            ? item.coverImage.sizes?.thumbnail?.url
            : ''
        }`,
      }
    }
  }
  return null
}

export const LightGalleryComponent = ({ gallery }: IProps) => {
  const lightGallery = useRef<LightGalleryObject>(null)

  const onOpen = useCallback((index: number) => {
    lightGallery.current?.openGallery(index)
  }, [])

  const dynamicGallery: GalleryItem[] = []
  const mergedGallery: { media?: string | Media | null; id?: string | null }[] | null = []

  gallery?.map((item) => {
    if (typeof item === 'object') {
      const media = splitImageOrVideo(item)
      if (media) {
        dynamicGallery.push({...media, alt: media.title})
      }
      mergedGallery.push({ media: item })
    }
  })

  return (
    <LightGallery
      onInit={(detail) => {
        if (detail.instance) {
          lightGallery.current = detail.instance
        }
        const facebookLink = document.querySelector('.lg-share-facebook') as HTMLAnchorElement | null;
        if(facebookLink && !facebookLink.hasAttribute('href')){
          facebookLink.href = '';
        }

        const twitterLink = document.querySelector('.lg-share-twitter') as HTMLAnchorElement | null;
        if(twitterLink && !twitterLink.hasAttribute('href')){
          twitterLink.href = '';
        }
      }}
      dynamic={true}
      plugins={[lgHash, lgShare, lgThumbnail, lgVideo]}
      dynamicEl={dynamicGallery}
      pinterest={false}
      preload={0}
      mobileSettings={{dynamic: true, zoom: true}}
    >
      <CarouselGalleryComponent gallery={mergedGallery} onOpen={onOpen} />
    </LightGallery>
  )
}

export default LightGalleryComponent
